import { render } from "./FormColegio.vue?vue&type=template&id=386c4062&ts=true"
import script from "./FormColegio.vue?vue&type=script&lang=ts"
export * from "./FormColegio.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__